module.exports = __webpack_public_path__ + "img/class4.9011796d.png";